function getQueryParams(query, asPath, keys) {
  const urlParams = new URLSearchParams(asPath?.split("?")[1]);
  const queryParams = {};
  keys.forEach((key) => {
    const value = query && query[key] || urlParams.get(key);
    if (typeof value === "string") {
      queryParams[key] = value;
    }
  });
  return queryParams;
}
const errorResponse = () => {
  return { statusCode: 500 };
};
export {
  errorResponse as e,
  getQueryParams as g
};
//# sourceMappingURL=error-response.js.map
